<template>
  <div class="page-content">
    <RichContent v-if="pageContent" :content="pageContent" />
    <p v-else>This department doesn’t have a description yet</p>
  </div>
</template>

<script>
import RichContent from '@/components/RichContent'
import useMeta from '@/composables/useMeta'

export default {
  components: { RichContent },
  setup() {
    const { catalogWideMetaTitle } = useMeta()
    return { catalogWideMetaTitle }
  },
  props: {
    department: {
      type: Object,
      required: true,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  head() {
    return {
      title: `${this.department.displayName} Department Overview | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Overview | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  computed: {
    pageContent() {
      return this.$route.query.preview
        ? this.page.temporaryContent
        : this.page.content
    },
  },
}
</script>
